import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Carousel, Video } from 'components';
import { FBHeader } from 'components/SocialPreviews';
import * as styles from './FBDesktopPreview.scss';
var FBDesktopPreview = (_dec = connect(function (state) {
  return {
    organization: state.organization.current
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(FBDesktopPreview, _Component);

  var _super = _createSuper(FBDesktopPreview);

  function FBDesktopPreview(props) {
    _classCallCheck(this, FBDesktopPreview);

    return _super.call(this, props);
  }

  _createClass(FBDesktopPreview, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          adDetails = _this$props.adDetails,
          adType = _this$props.adType,
          fbAcct = _this$props.fbAcct;
      var paddingBottom = '53%';

      if (adType === 'pageLikes') {
        paddingBottom = '37%';
      }

      var style = {
        paddingBottom: paddingBottom
      };
      var videoTags = null;
      var imageTags = null;

      if (this.props.formatType === 'image') {
        style.backgroundImage = adDetails['image-ad-upload'] && adDetails['image-ad-upload'][0] ? "url(".concat(adDetails['image-ad-upload'][0], ")") : 'url(https://s3.amazonaws.com/likeabucket/user_upload/22/SkfpFgfaX.jpeg)';
      } else if (this.props.formatType === 'video') {
        if (adDetails['video-ad-upload']) {
          if (Array.isArray(adDetails['video-ad-upload'])) {
            videoTags = adDetails['video-ad-upload'].map(function (url, idx) {
              return url.indexOf('blarplesnurf') === -1 || url.indexOf('blarplesnurf-staging') === -1 ? /*#__PURE__*/React.createElement(Video, {
                src: url,
                key: idx,
                style: {
                  width: '100%',
                  height: '100%'
                },
                autoPlay: true,
                loop: true,
                controls: true,
                muted: true
              }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Your video is being processed. One moment..."), /*#__PURE__*/React.createElement("i", {
                className: "fa fa-spinner fa-spin"
              }));
            });
          }
        }
      } else {
        console.log('carousel adDetails');
        console.log(adDetails);
      }

      if (this.props.formatType === 'carousel') {
        imageTags = /*#__PURE__*/React.createElement(Carousel, {
          slides: adDetails['carousel-ad-upload'],
          className: style.img
        });
      } else if (this.props.formatType === 'image') {
        imageTags = /*#__PURE__*/React.createElement("div", {
          className: styles.img,
          style: style
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: 500,
          margin: '0'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.mobilePreview
      }, this.props.adType === 'pageLikes' && /*#__PURE__*/React.createElement("div", {
        className: styles.suggestedPage
      }, "Suggested Page"), /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement(FBHeader, {
        avatarUrl: fbAcct.avatarImageUrl,
        dateText: "Sponsored",
        pageName: fbAcct.username
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.description
      }, adDetails.description), imageTags, videoTags, /*#__PURE__*/React.createElement("div", {
        className: styles.bottom
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.textWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.title
      }, /*#__PURE__*/React.createElement("strong", null, fbAcct.username)), /*#__PURE__*/React.createElement("div", {
        className: styles.subTitle
      }, adDetails.headline), /*#__PURE__*/React.createElement("div", {
        className: styles.subTitle
      }, "3,241 people like this")), /*#__PURE__*/React.createElement("div", {
        className: styles.fbButtonWrap
      }, this.props.adType === 'pageLikes' ? /*#__PURE__*/React.createElement("button", {
        className: styles.fbButton
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-thumbsup ".concat(styles.thumbOnButton)
      }), "Like Page") : /*#__PURE__*/React.createElement("button", {
        className: styles.fbButton
      }, "Learn More")))));
    }
  }]);

  return FBDesktopPreview;
}(Component), _defineProperty(_class2, "propTypes", {
  organization: PropTypes.object.isRequired
}), _defineProperty(_class2, "defaultProps", {
  fbAcct: {
    username: 'Facebook Username',
    avatarUrl: ''
  }
}), _temp)) || _class);
export default FBDesktopPreview;